export default "__VITE_ASSET__Wl$i5V9c__"